import fetch from '../Services/fetch'
import fetchClients from '../../../Core/Services/fetchClients'

export default () => (dispatch) => {
  
  dispatch(fetch())

  dispatch(fetchClients())
  
}